import React, { Component } from "react";

const footerStyle = {
  position: 'fixed',
  bottom: '0',
  width: '100%',
/*   marginTop: '10px',
  padding: '10px' */
};

//https://stackoverflow.com/questions/61726093/how-to-solve-hidden-text-on-scrolling-footer-that-hides-text-of-body-in-react

class MyFooter extends Component {
  render() {
    return (
        <div style={{paddingTop: '100px'}}>
          {/* <footer className="footer mt-auto py-3 bg-light" style={{position: 'fixed', bottom: '0', width: '100%'}}> */}
          <footer className="footer mt-auto py-3 bg-light" style={footerStyle}>
            <div className="container d-flex align-items-center justify-content-center">
              <span className="text-muted">&#169; Return and Risk Consulting Pte Ltd 2021. All Rights Reserved.</span>
            </div>
          </footer>
        </div>
    );
  }
}
 
export default MyFooter;
